import forge from 'apis/forge';
import { ChatMode, ChatStatus, UserChatEntry } from 'dragonmouse-shared/interfaces';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

export type ChoiceChatType = 'scene' | 'ds';

interface Props {
	options: Array<{ label: string }>;
	chatType: ChoiceChatType;
}

const ChoiceAction = ({ options, chatType }: Props) => {
	const { chatId, isMobile } = useSelector((r: RootReducer) => ({
		chatId: chatType === 'scene' ? r.mode.activeSceneChatId : r.mode.activeDsChatId,
		isMobile: selectIsMobile(r.mode),
	}));

	const onSelect = async (label: string) => {
		if (!chatId) return;
		const entry: UserChatEntry = {
			kind: 'user',
			message: label,
			sourceFrameIds: [],
			attachments: [],
		};
		if (chatType === 'scene') {
			await forge.updateSceneChat({
				update: {
					id: chatId,
					metadata: { status: ChatStatus.PROCESSING, statusMessage: '' },
				},
			});
			await forge.addSceneChatUserEntry.withToast()({
				chatId,
				entry,
				chatMode: ChatMode.DESIGN_AND_CHAT,
				style: null,
			});
		} else {
			await forge.updateDsChat({
				update: {
					id: chatId,
					metadata: { status: ChatStatus.PROCESSING, statusMessage: '' },
				},
			});
			await forge.dsChatAddUserEntry.withToast()({
				dsChatId: chatId,
				entry,
				chatMode: ChatMode.DESIGN_AND_CHAT,
			});
		}
	};

	return (
		<S.Base>
			{options.map((opt) => (
				<S.Option
					key={opt.label}
					type="button"
					isMobile={isMobile}
					onClick={() => onSelect(opt.label)}
				>
					{opt.label}
				</S.Option>
			))}
		</S.Base>
	);
};

export default ChoiceAction;
